<template>
	<div class="radioBox" :class="formClass">
		<FormTitle
			:text="title"
			:required="required"
			:error="errorText ? true : false"
			:disabled="disabled"
			:kizuna-type="kizunaType"
		/>
		<ul
			class="radioBtn"
			:class="[formClass, { error: errorClass, copy: copyFlag }]"
		>
			<li v-for="(item, value) in radioItem" :key="value" class="radioBtn_item">
				<input
					type="radio"
					:id="name + '-' + value"
					:value="value"
					:name="name"
					:disabled="disabled"
					class="radioBtn_itemInput"
					tabindex="1"
					:checked="value == modelValue"
					@change="updateValue"
				/>
				<label :for="name + '-' + value" class="font-bold">{{ item }}</label>
			</li>
		</ul>
	</div>
	<ErrorText :text="errorText" />
</template>

<script setup>
import ErrorText from "@/components/atoms/ErrorText.vue";
import FormTitle from "@/components/atoms/FormTitle.vue";
import { computed, defineEmits, defineProps, onMounted } from "vue";

/* ---------------------------------------------------------------------------
	emits
---------------------------------------------------------------------------- */
const emit = defineEmits(["update:modelValue"]);
/* ---------------------------------------------------------------------------
	props
---------------------------------------------------------------------------- */
const props = defineProps({
	modelValue: [String, Number],
	radioItem: [String, Object],
	title: String,
	name: String,
	disabled: Boolean,
	required: Boolean,
	formClass: [String, Array],
	errorText: String,
	copyFlag: Boolean,
	kizunaType: Number
});
/* ---------------------------------------------------------------------------
	バリデーション
---------------------------------------------------------------------------- */
const errorClass = computed(() => {
	return props.errorText;
});
/* ---------------------------------------------------------------------------
	ラジオボタンをチェックしたときの処理
---------------------------------------------------------------------------- */
function updateValue(e) {
	emit("update:modelValue", e.target.value);
}
/* ---------------------------------------------------------------------------
	mounted
---------------------------------------------------------------------------- */
onMounted(() => {});
</script>
<style scoped lang="scss">
@use "/resources/css/_adjust.scss" as *;
.radioBtn {
	z-index: 1;
	position: relative;
	display: inline-block;
}
// 技能実習責任者講習で使用
.radioBtn.noActive:after {
	left: 0;
	content: "";
	width: 100%;
	height: 8px;
	z-index: -1;
	bottom: -5px;
	display: inline;
	position: absolute;
	border-radius: 5px;
	background: #e2f2d9;
}
.radioBtn_item {
	display: inline-block;
	&.disabled {
		color: #ddd;
	}
}
.radioBtn_item-block {
	display: block;
}
.radioBtn input[type="radio"] {
	width: 0;
	height: 0;
	padding: 0;
	border: none;
	appearance: none;
	border-color: #fff;
	-ms-appearance: none;
	-moz-appearance: none;
	-webkit-appearance: none;
	border-top-color: currentcolor;
	border-right-color: currentcolor;
	border-bottom-color: currentcolor;
	border-left-color: currentcolor;
}
.radioBtn input[type="radio"]:checked + label:before {
	border: 2px solid $bg-blue2;
	animation: ripple 0.2s linear forwards;
}
.radioBtn input[type="radio"]:checked + label:after {
	transform: scale(1);
}
.radioBtn label {
	cursor: pointer;
	min-height: 20px;
	margin-bottom: 0;
	position: relative;
	font-size: 1.4rem;
	display: inline-block;
	padding: 2px 6px 0px 25px;
	color: rgba(51, 51, 51, 0.3);
}
.radioBtn input[type="radio"]:checked + label {
	color: $bg-blue2;
}
.radioBtn label:before,
.radioBtn label:after {
	content: "";
	position: absolute;
	border-radius: 50%;
	transition: all 0.3s ease;
	transition-property: transform, border-color;
}
.radioBtn label:before {
	left: 0;
	top: 3px;
	width: 20px;
	height: 20px;
	border: 2px solid #ccc;
}
.radioBtn label:after {
	top: 7px;
	left: 4px;
	width: 12px;
	height: 12px;
	transform: scale(0);
	background: $bg-blue2;
}
// 複製用
.copy.radioBtn label:after {
	background: #77c250;
}
.radioBtn_itemInput:focus ~ label {
	color: #0086e6;
}
.radioBtn_itemInput:focus + label {
	color: #0086e6;
}
.radioBtn-bg1 input[type="radio"]:checked + label:before {
	border: 2px solid $bg-blue2;
}
.radioBtn-bg1 input[type="radio"]:checked + label:after {
	background: $bg-blue2;
}
.radioBtn-bg1 input[type="radio"]:checked + label {
	color: rgba(51, 51, 51, 1);
}
/* 非活性の場合 */
.radioBtn input[type="radio"]:disabled + label {
	color: #e6e6e6;
}
.radioBtn input[type="radio"]:disabled + label:before {
	border-color: #e6e6e6;
}
.radioBtn input[type="radio"]:disabled + label:after {
	background: #e6e6e6;
}
.radioBtn input[type="radio"]:checked:disabled + label {
	color: #a0d5de;
}
.radioBtn input[type="radio"]:checked:disabled + label:before {
	border-color: #a0d5de;
}
.radioBtn input[type="radio"]:checked:disabled + label:after {
	background: #a0d5de;
}
@keyframes ripple {
	0% {
		box-shadow: 0px 0px 0px 1px rgba(241, 55, 87, 0);
	}
	50% {
		box-shadow: 0px 0px 0px 15px rgba(241, 55, 87, 0.1);
	}
	100% {
		box-shadow: 0px 0px 0px 15px rgba(241, 55, 87, 0);
	}
}
</style>
